import { useEffect, useState } from 'react'
import { EventDetails } from 'types/Event'

interface UseWizardProps {
    initialData?: EventDetails
}

export const useWizard = ({ initialData }: UseWizardProps) => {
    const [currentStep, setCurrentStep] = useState(1)
    const [eventData, setEventData] = useState<Record<string, any>>(initialData || {})

    const isEditMode = !!initialData

    useEffect(() => {
        if (initialData) setEventData(initialData)
    }, [initialData])

    const handleNextStep = (stepData: any) => {
        setEventData((prev) => ({ ...prev, ...stepData }))
        setCurrentStep((prev) => prev + 1)
    }

    const handlePreviousStep = () => setCurrentStep((prev) => prev - 1)

    return {
        currentStep,
        eventData,
        isEditMode,
        handleNextStep,
        handlePreviousStep,
    }
}
